import { render, staticRenderFns } from "./TeacherListeningBadge.vue?vue&type=template&id=65a33128&scoped=true"
import script from "./TeacherListeningBadge.vue?vue&type=script&lang=ts"
export * from "./TeacherListeningBadge.vue?vue&type=script&lang=ts"
import style0 from "./TeacherListeningBadge.vue?vue&type=style&index=0&id=65a33128&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a33128",
  null
  
)

export default component.exports
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QBadge,QIcon});
